<div class="bg-app">
  <app-header></app-header>
  <div class="min-vh-100">
    <router-outlet></router-outlet>
  </div>
</div>
